import React, { Component } from 'react';
import ContactUs from '../contactus/contactus.jsx'
import AuthNavbar from '../navigation/authnavigation.jsx'
import LeftLink from '../leftlink/leftlink.jsx'

class NavContact extends Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>

                </div>
                <div className="container" style={{ marginTop: "80px" }}>
                    <div className="row">
                        <div className="col-sm-3 box-shadow-style nopadding">
                            <LeftLink />
                        </div>
                        <div className="col-sm-9" style={{ padding: "0px 30px" }}>

                            <div className="row box-shadow-style" style={{ padding: "0px 0px", minHeight: "476px" }}>
                                <ContactUs />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NavContact;


// WEBPACK FOOTER //
// ./src/components/navcontact/navcontact.jsx